
<div class="errorPage" *ngIf="!(loading$ | async)">
    <div class="errorPage-container">
        <div class="errorPage-img">
            <img src="../images/no-data.svg" alt="">
        </div>
        <div class="errorPage-title">
            Hey, it feels so sad!
        </div>
        <div class="errorPage-text">
            We couldn't find the page you're looking for.<br>
            There is some mistake in url or We are having problem to fetching the data.
        </div>
        <a [href]="finkupUrl" class="btn btn-primary">Discover Other Stuff</a>
    </div>
</div>
